import { UseRecordsOptions } from "../../api/useRecords";
import { filterUsersRoles } from "../../utils/filterUsersRoles";

export const staffAgreementsOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["id", "content"],
        fieldTypesToRemove: ["alias"],
    },
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "user",
                filter: filterUsersRoles,
                enabled: true
            },
            {
                field:"contracts",
                fileFolder: "77846f3c-eb84-4e52-9adc-bfd16f7cd107"
            },
            {
                field:"documents",
                fileFolder: "77846f3c-eb84-4e52-9adc-bfd16f7cd107"
            }
        ],
    },
} as unknown as UseRecordsOptions;
